import type { UserProfile } from '../types';
import { firstTrinIdInTier } from './curriculum';

/** After V3.3: users who finished niveau 4 can start niveau 5. */
export function migrateUserToV33(user: UserProfile): UserProfile {
  let next = user;

  if (
    user.completedTierIds.includes('niveau-4') &&
    !user.completedTierIds.includes('niveau-5')
  ) {
    const n5First = firstTrinIdInTier('niveau-5');
    if (n5First) {
      const onN4 =
        user.currentTrinId.startsWith('niveau-4') ||
        user.currentTrinId === 'checkpoint-after-niveau-4';
      if (onN4) {
        next = { ...next, currentTrinId: n5First };
      }
    }
  }

  if (
    user.completedTierIds.includes('niveau-5') &&
    !user.completedTierIds.includes('niveau-6')
  ) {
    const n6First = firstTrinIdInTier('niveau-6');
    if (n6First) {
      const onN5 =
        user.currentTrinId.startsWith('niveau-5') ||
        user.currentTrinId === 'checkpoint-after-niveau-5';
      if (onN5) {
        next = { ...next, currentTrinId: n6First };
      }
    }
  }

  return next;
}
